<mat-form-field floatLabel="never" [ngClass]="classField()">
  <mat-select placeholder="..." [formControl]="control()">
    <mat-option [value]="'Family'"><span translate>Single / family</span></mat-option>
    @if (rentalType() === 'RoomRental' || rentalType() === 'HouseSharing') {
      <mat-option [value]="'Students'">
        <span translate>Students</span>
      </mat-option>
    }
    @if (rentalType() !== 'Regular') {
      <mat-option [value]="'LaborOrKnowledgeMigrants'">
        <span translate>Labor / knowledge migrants</span>
      </mat-option>
    }
    @if (rentalType() === 'ShortStay') {
      <mat-option [value]="'Tourists'">
        <span translate>Tourists</span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>